module.exports = __webpack_public_path__ + "img/element9.c108cfab.svg";